import Vue from "vue";
import Vuex from "vuex";

import { Login, Register, Common, Lottery, Game, Integral, Help, acmc } from "tcg-web-view";
import localStore from "./localStore";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    Login,
    Register,
    Common,
    Lottery,
    Game,
    Integral,
    Help,
    localStore,
    acmc,
  },
});
export default store;
